export default {
  sign_in_title: "Melden Sie sich bei Ihrem Konto an",
  sign_up_title: "Erstellen Sie ein neues Konto",
  email: "E-Mail-Adresse",
  email_required: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  email_placeholder: "ihre{0}beispiel.com",
  email_invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  password: "Passwort",
  password_placeholder: "Geben Sie Ihr Passwort ein",
  password_required: "Bitte geben Sie Ihr Passwort ein",
  password_invalid:
    "Das Passwort muss mindestens 8 Zeichen lang sein und Buchstaben, Zahlen und Sonderzeichen enthalten",
  forgot_password: "Passwort vergessen?",
  confirm_password_required: "Bitte bestätigen Sie Ihr Passwort",
  confirm_password_placeholder: "Passwort bestätigen",
  passwords_do_not_match: "Die beiden eingegebenen Passwörter stimmen nicht überein",
  or: "Oder",
  no_account: "Kein Konto?",
  have_account: "Haben Sie bereits ein Konto?",
  error: "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre E-Mail und Ihr Passwort.",
  google_error: "Google-Anmeldung fehlgeschlagen",
  x_error: "X-Anmeldung fehlgeschlagen",
  linkedin_error: "LinkedIn-Anmeldung fehlgeschlagen",
  google_sign_in: "Mit Google anmelden",
  google_sign_up: "Mit Google registrieren",
  apple_sign_in: "Mit Apple anmelden",
  apple_sign_up: "Mit Apple registrieren",
  twitter_sign_in: "Mit X anmelden",
  twitter_sign_up: "Mit X registrieren",
  linkedin_sign_in: "Mit LinkedIn anmelden",
  linkedin_sign_up: "Mit LinkedIn registrieren",
  aria_card: "Anmeldekarte",
  aria_email: "E-Mail-Eingabefeld",
  aria_password: "Passwort-Eingabefeld",
  aria_submit: "Senden-Schaltfläche",
  aria_google: "Google-Anmelde-Schaltfläche",
  aria_linkedin: "LinkedIn-Anmelde-Schaltfläche",
  aria_switch_mode: "Zwischen Anmelden/Registrieren wechseln",
  welcome: "Willkommen bei TaxEcoBit",
  subtitle: "EU-CBAM-konforme Kohlenstoffsteuerberechnungsplattform",
  benefit1: "Genaue Kohlenstoffsteuerberechnung mit weniger als 10 % Fehlerquote",
  benefit2: "Unterstützt mehrere Transportmodi und benutzerdefinierte Faktoren",
  benefit3: "Unterstützt API-Integration",
  benefit4: "Generiert konforme Berichte, die den Anforderungen des EU-CBAM entsprechen",
  user_friendly: "Benutzerfreundlich",
  secure_reliable: "Sicher und zuverlässig",
  cloud_sync: "Cloud-Synchronisation",
  invite_code: "Einladungscode",
  invite_code_placeholder: "Bitte Einladungscode eingeben (optional)",
  invite_code_detected: "Einladungscode erkannt",
  invited_by_user: "Eingeladen von",
  sign_out: "Abmelden",
  agreement_prefix: "Durch die Registrierung bei TaxEcoBit stimmen Sie unseren",
  terms: "Nutzungsbedingungen",
  and: "und",
  privacy: "Datenschutzrichtlinie",
  agreement_required: "Bitte stimmen Sie zuerst der Datenschutzrichtlinie zu",
  complete_verification: "Bitte schließen Sie zuerst die Verifizierung ab",
  loading_verification: "Verifizierung wird geladen...",
  verification_failed: "Verifizierung fehlgeschlagen, bitte erneut versuchen",
};
